import React from 'react';
import {
    Table,
    Tr,
    Td,
    Th,
    css,
    Header,
    Div,
} from "@bdfx/fukit"
import {clip, shadow} from "../homepage/section"
import ctrans from "../../common/trans"
import {formatInt} from "../../common/format"

function Categories({top_categories}) {
    return (
     <Style className="section categories npbreak">
        <div>
            <Header type={2}>
                {ctrans("products_histogram_by_category")}
            </Header>
            <Div maxWidth="1100px" margin="auto">
                <Table className="heatmap-table" width="100%" header={[
                    <Th key={"label"} align="left" title={ctrans("category_histogram_label")}>{ctrans("category_histogram_label")}</Th>,
                    <Th key={1}>1.</Th>,
                    <Th key={2}>2.</Th>,
                    <Th key={3}>3.</Th>,
                    <Th key={4}>4.</Th>,
                    <Th key={5}>5.</Th>,
                    <Th key={6}>6.</Th>,
                    <Th key={7}>7.</Th>,
                    <Th key={8}>8.</Th>,
                    <Th key={9}>9.</Th>,
                    <Th key={10}>10+</Th>,
                    <Th key={"sum"} align="right" title={ctrans("products_sum")}>{ctrans("products_sum")}</Th>,
                ]}>
                {top_categories.map(category => (
                    <Tr key={category.name}>
                        <Td align="left" title={category.name}>{category.name}</Td>
                        {Object.keys(category.positions).map(position => {
                            const percent = Math.round(category.positions[position] * 100 / category.count)
                            return <Heat key={position} className={percent < 20 ? "light" : ""} value={percent} />
                        })}
                        <Td align="right">{formatInt(category.count)}</Td>
                    </Tr>
                ))}
                </Table>
            </Div>

        </div>
    </Style>
  );
}
const Heat = css("td")({
    padding: 0,
    textAlign: "center",

    color: "white",
    "&.light": {
        color: "#aaa",
    },
    fontWeight: "bold",
    willChange: "background",
    transition: "background 0.1s",
    ":hover": {
        background: "rgba(255,255,255,0)",
        color: "white !important",
    },
}, props => ({
    background: "rgba(255,255,255," + ((100-(props.value*2))/100) + ")",
    ":before": {
        content: '"'+props.value+' %"',
    },
}))


const Style = css("div")({
    filter: shadow,
    position: "relative",
    zIndex: 20,
    ".heatmap-table": {
        "th": {
            whiteSpace: "nowrap",
            width: "1%",
            textOverflow: "ellipsis",
            overflow: "hidden",
    },
        "tr": {
            background: "rgb(135,217,69)",
            "td:first-child,td:last-child": {
                background: "#fff",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "200px",
            },
        },
        "tr:nth-child(2n)": {
            background: "rgb(60,60,60)",
            "td:first-child,td:last-child": {
                background: "#f6f6f6",
            },
        },
    },

    "td:last-child": {
        fontWeight: "bold",
    },
    "> div": {
        marginTop: "-320px",
        paddingTop: "350px",
        paddingBottom: "120px",
        clipPath: clip,
        background: "#fff",
        "> div": {
            maxWidth: "1200px",
            margin: "auto",
            },
    },
    ".fuk-header.h2": {
        marginBottom: "1.5em",
    },

})

export default Categories;
